import { render, staticRenderFns } from "./PageConfigDialog.vue?vue&type=template&id=006bdef4&"
import script from "./PageConfigDialog.vue?vue&type=script&lang=js&"
export * from "./PageConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./PageConfigDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports